export default {
    path: "/version",
    name: "version",
    meta: {
        icon: "md-calendar",
        access: "menu_vertion_library",
        title: "版本管理",
    },
    component: () => import("@/views/Main.vue"),
    children: [
        {
            path: "library",
            name: "library",
            meta: {
                icon: "md-filing",
                access: "menu_vertion_library",
                title: "版本单",
            },
            component: () => import("@/views/testing/version.vue"),
        },
    ],
};
